import React, { useEffect, useRef, useState } from "react";
import { Button, Form, Input, Radio, Select, Spin, Table } from "antd";
import { sizeChartData, sizeChartDataNew } from "../../utils/sizeChart";
import logo from "../../assets/images/logo.png";
import xlsx from "../../assets/images/ico_xls_sm.gif";
import { CSVLink } from "react-csv";
import { ReadCookie } from "../../utils/readCookie";
import { useDispatch, useSelector } from "react-redux";
import { GetallocationReport } from "../../redux/actions/allocationReport.action";
import * as XLSX from 'xlsx';
import moment from "moment";
import { useDownloadExcel } from "react-export-table-to-excel";
import { TabTitle } from "../../utils/GeneralFunction";
import numeral from "numeral";

const AllocationReport = ({ token }) => {
  TabTitle("Allocation Report")
  const [columns, setColumns] = useState([]);
  const [loading, setLoading] = useState(false);
  const menuId = ReadCookie("menuId");
  const userName = ReadCookie("name");
  const tableRef = useRef(null);
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const [searchBy, setSearchBy] = useState("sku");

  const {
    allocationReport
  } = useSelector((state) => state);


  const sortedAllocationData = (allocationReport?.payload?.data || []).map(item => {
    const sortByDateKey = (obj) => {
      if (!obj || typeof obj !== "object") return {};

      return Object?.fromEntries(
        Object.entries(obj)?.sort(([keyA], [keyB]) => {
          // console.log("keyA", keyA)
          // console.log("keyB", keyB)
          const dateA = keyA?.match(/\(\s*(\d{2}-\d{2}-\d{4})\s*\)/)?.[1];
          const dateB = keyB?.match(/\(\s*(\d{2}-\d{2}-\d{4})\s*\)/)?.[1];

          if (!dateA || !dateB) return 0;
          return new Date(dateA) - new Date(dateB);
        })
      );
    };

    return {
      ...item,
      ...sortByDateKey(item.dynamic_data),
      dynamic_data: sortByDateKey(item.dynamic_data)
    };
  });

  // const exportToExcel = () => {
  //   const data = sortedAllocationData || [];
  //   const sizeFields = Array.from({ length: 16 }, (_, i) => `qty_${i + 1}`);
  //   const shortagesKeys = [...new Set(data.flatMap(item => Object.keys(item.dynamic_data || {})))];
  //   const fulfillmentKeys = [...new Set(data.flatMap(item => Object.keys(item.fulfillment_data || {})))];
  //   const worksheetData = [
  //     ['Order #', 'SKU', 'Inseam', 'Fulfilment Type', 'T-Jacket', '"2/3"', '"4/5"', '"6/6X"', ...Array(13).fill("-"), 'Total', ...shortagesKeys.map(k => `Shortage (ETA): ${k}`),
  //       ...fulfillmentKeys.map(k => `Fulfilled (ETA): ${k}`)
  //     ],
  //     [...Array(4).fill(""), 'Shirt/RTW-P', '1XL', '2XL', '3XL', ...Array(13).fill("-")],
  //     [...Array(4).fill(""), 'Shirt/RTW-R', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', ...Array(9).fill("-")],
  //     [...Array(4).fill(""), 'Y-Adult', '00', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', ...Array(4).fill("-")],
  //     [...Array(4).fill(""), 'W-Pus', '10W', '12W', '14W', '16W', '18W', '20W', '22W', '24W', '26W', '28W', '30W', '32W', ...Array(4).fill("-")],
  //     [...Array(4).fill(""), 'Kids', '2', '3', '4', '5', '6', '6x', '7', '7x', '8', '10', '12', '14', '16', '18', '20', '-'],
  //     [...Array(4).fill(""), 'Men', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '38', '40', '42', '44', '46', '48'],
  //     [...Array(4).fill(""), 'Women', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37'],
  //   ];

  //   // Actual data rows
  //   data.forEach((item, index) => {
  //     worksheetData.push([
  //       item.order_header_no || '',
  //       item.sku || '',
  //       item.inseam || '',
  //       item.fullfill_type || '',
  //       '',
  //       ...sizeFields.map(key => item[key] ?? 0),
  //       item.totalqty || 0,
  //       ...shortagesKeys.map(key => item.dynamic_data?.[key] ?? 0),
  //       ...fulfillmentKeys.map(key => item.fulfillment_data?.[key] ?? 0)
  //     ]);
  //   });

  //   const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

  //   // Merge static headers (#, Order # etc)
  //   worksheet['!merges'] = [
  //     { s: { r: 0, c: 0 }, e: { r: 7, c: 0 } },
  //     { s: { r: 0, c: 1 }, e: { r: 7, c: 1 } },
  //     { s: { r: 0, c: 2 }, e: { r: 7, c: 2 } },
  //     { s: { r: 0, c: 3 }, e: { r: 7, c: 3 } },
  //     { s: { r: 0, c: 21 }, e: { r: 7, c: 21 } }, // Total Qty
  //     ...shortagesKeys.map((_, i) => ({
  //       s: { r: 0, c: 22 + i },
  //       e: { r: 7, c: 22 + i },
  //     })),

  //     // Dynamic fulfillments (start after shortages)
  //     ...fulfillmentKeys.map((_, i) => ({
  //       s: { r: 0, c: 22 + shortagesKeys.length + i },
  //       e: { r: 7, c: 22 + shortagesKeys.length + i },
  //     })),
  //   ];

  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Sales Target");

  //   XLSX.writeFile(workbook, `Allocation-Report-${moment().format("MM-DD-YY")}.xlsx`);
  // }

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Allocation-Report",
    sheet: "Allocation-Report",
  });

  const fetchData = () => {
    const addPrefixToKeys = (data, prefix) => {
      if (Array.isArray(data)) {
        return data.map(item => addPrefixToKeys(item, prefix));
      } else if (typeof data === 'object' && data !== null) {
        const newData = { ...data };
        if (newData.dataIndex) {
          newData.dataIndex = `${prefix}${newData.dataIndex}`;
        }
        if (newData.key) {
          newData.key = `${prefix}${newData.key}`;
        }
        if (newData.children) {
          newData.children = addPrefixToKeys(newData.children, prefix);
        }
        return newData;
      }
      return data;
    };
    const staticCols = [
      { title: '#', dataIndex: 'index', key: 'index', render: (text, record, index) => { return index + 1 } },
      { title: "Gender", dataIndex: "gender_name", key: "gender_name" },
      { title: "Season", dataIndex: "new_season", key: "new_season" },
      { title: "SKU", dataIndex: "sku", key: "sku" },
      { title: "Inseam", dataIndex: "inseam", key: "inseam" },
      { title: "Style", dataIndex: "style_name", key: "style_name" },
      { title: "Wash", dataIndex: "wash_name", key: "wash_name" },
      { title: "Order Date", dataIndex: "order_date", key: "order_date", render: (text) => moment(text).format("MM-DD-YYYY") },
      { title: "Start Date", dataIndex: "start_date", key: "start_date", render: (text) => moment(text).format("MM-DD-YYYY") },
      { title: "Cancel Date", dataIndex: "cancel_date", key: "cancel_date", render: (text) => moment(text).format("MM-DD-YYYY") },
      { title: "Customer", dataIndex: "customer_name", key: "customer_name" },
      { title: "Term", dataIndex: "payment_term", key: "payment_term" },
      { title: "Order #", dataIndex: "order_header_no", key: "order_header_no" },
      { title: "PO", dataIndex: "reference_no", key: "reference_no" },
      { title: "Region", dataIndex: "region_name", key: "region_name" },
      { title: "SalesPerson", dataIndex: "salesperson_name", key: "salesperson_name" },
      { title: "Cost", dataIndex: "rate", key: "rate", render: (text) => `$${numeral(text).format("0,0.00")}` },
      { title: "Amount", dataIndex: "amount", key: "amount", render: (text) => `$${numeral(text).format("0,0.00")}` },
      { title: "Extension Needed", dataIndex: "extended", key: "extended" },
      { title: "Last Fulfillment Location", dataIndex: "fullfill_type", key: "fullfill_type" },
    ];

    const shortagesCols = [
      ...new Set(
        sortedAllocationData.flatMap(item => {
          return Object.keys(item.dynamic_data || {}).filter(key => {
            return !key.toLowerCase().includes('qty');
          });
        })
      )
    ].map(key => ({
      title: key[0].toUpperCase() + key.slice(1),
      dataIndex: key,
      key,
      align: "right",
      render: (text) => {
        if (!text) return null;
        const [main, bracket] = text.split(/[()]/)
        const mainValue = parseInt(main);
        const bracketValue = parseInt(bracket);

        if (mainValue === 0 && bracketValue === 0) {
          return "0";
        }
        return (
          <span>
            {mainValue}
            {bracketValue !== 0 && !isNaN(bracketValue) ? (
              <span style={{ color: "red" }}>({bracketValue})</span>
            ) : null}
          </span>
        );
      }
    }));

    let data = []
    shortagesCols.forEach(x => {
      data.push(...addPrefixToKeys(sizeChartDataNew.columns, x.key));
      data.push(x);
    })

    let previousTitle = null;
    let updatedData = data?.reverse().map((item) => {
      if (item?.title) {
        previousTitle = item.title;
        const cleanedTitle = item.title.replace(/\s*\(\d{4}-\d{2}-\d{2}\)/, '').trim();
        item.title = "Total";
      } else if (item?.children) {
        item.title = `Availbility from ${previousTitle}`;
      }

      return item;
    }).reverse();

    setColumns([...staticCols, ...sizeChartData.columns,
    { title: "Total Qty", dataIndex: "totalqty", key: "totalqty", align: "right" },
    ...updatedData
    ]);
  }


  useEffect(() => {
    fetchData();
  }, [allocationReport?.payload?.data]);

  // useEffect(() => {
  //   setLoading(true)
  //   dispatch(GetallocationReport(token)).then((res => {
  //     setLoading(false)
  //   }));
  // }, [dispatch, token]);
  // 

  const onFinish = async () => {
    setLoading(true);
    await form.validateFields().then((values) => {
      dispatch(GetallocationReport(token, values)).then((res) => {
        if (res.type === "GET_ALLOCATION_REPORT_SUCCESS") {
          setLoading(false);
        }
      });
    }).catch((error) => {
      setLoading(false);
    })
  }


  return (
    <div className="header_class business_header_oms intransit">
      <div className="row justify-content-between business_class_oms distributor">
        <div className="col-3 d-flex align-items-start box-space">
          <div className="logobrand">
            <img id="ImgLogo" alt="logo" src={logo} />
          </div>
        </div>
        <div className="col-4 box-space right-content-header text-right">
          <div className=" d-flex justify-content-end">
            <div className=" d-flex justify-content-end mr-8">
              <div className="print_icon printing_class">
                <button
                  className="print_icon printing_class"
                  onClick={onDownload}
                  disabled={allocationReport?.loading}
                  style={{ background: 'none', border: 'none', padding: 0 }}
                >
                  <img
                    src={xlsx}
                    alt="Export to Excel"
                    title="Export to excel"
                    style={{ opacity: allocationReport?.loading ? 0.4 : 1 }}
                  />
                </button>
              </div>
            </div>
            <span style={{ fontSize: "small", fontWeight: "bolder" }}>
              Allocation Report
              <br />
              Rpt # 489
              <br />
              <p className=" mb-0">Rpt # 001_V4</p>
              Login as:{" "}
              <span id="lblSalesPerson" style={{ fontWeight: "bold" }}>
                {userName}
              </span>
            </span>
          </div>
        </div>

        <hr className="my-1" />
        <Form
          form={form}
          name="control-hooks"
          onFinish={onFinish} >
          <div className="main_form row">
            {/* <h3 className="filter-title">Group</h3> */}
            <Form.Item name="group">
              <Radio.Group style={{ width: 500 }} onChange={(e) => {
                setSearchBy(e.target.value);
                if(searchBy === "sku"){
                  form.setFieldsValue({ order_header: "" });
                } else {
                  form.setFieldsValue({ sku: "" });
                }
              }} defaultValue={searchBy}>
                <Radio value={"sku"}>SKU</Radio>
                <Radio value={"order_header"}>Order #</Radio>
              </Radio.Group>
            </Form.Item>
            <div className="col-12 col-md-3">
              <div className=" d-flex flex-row align-items-baseline">
                <label className="labels width44">{searchBy === "sku" ? "SKU" : "Order #"}</label>
                <div className="w-100">
                  <Form.Item name={searchBy} className="sku_input" rules={[{ required: true, message: `${searchBy === "sku" ? "SKU" : "Order #"} is required` }]}>
                    <Input size="small" className={"select_Inputs mb-0"} />
                  </Form.Item>
                </div>
              </div>
            </div>
            {/* Order Field */}
            {/* <div className="col-12 col-md-3">
              <div className=" d-flex flex-row align-items-baseline">
                <label className="labels width44">Order #</label>
                <div className="w-100">
                  <Form.Item name="order_header" className="sku_input">
                    <Input size="small" className={"select_Inputs mb-0"} />
                  </Form.Item>
                </div>
              </div>
            </div> */}
            <div className="col-12 col-md-3" style={{ display: "flex", height: 30, marginTop: 2 }}>
              <Button
                type="primary"
                htmlType="submit"
                className="submit-btn-btm m-0"
                disabled={loading}
              >
                Generate
              </Button>
            </div>
          </div>
        </Form>
      </div>

      <div
        className="table_content international_order"
        ref={tableRef}
      >
        <div className="overflow">
          {allocationReport?.payload?.data !== undefined ?
            (
              allocationReport?.payload?.data.length > 0 ? (
                <Table
                  className="test04 mt-3 sales_target_report_table_new sales_report_res_table 
                    sales_target_report_table_dashboard speciality_state bottom-align-th"
                  style={{ height: "auto !important" }}
                  columns={columns}
                  dataSource={sortedAllocationData}
                  loading={allocationReport.loading}
                  pagination={{ pageSize: 500 }}
                  scroll={{ x: 'max-content' }}
                  summary={() => {
                    const data = sortedAllocationData || [];

                    const sizeTotals = {};
                    const sizeFieldKeys = Array.from({ length: 16 }, (_, i) => `qty_${i + 1}`);

                    sizeFieldKeys.forEach(key => {
                      sizeTotals[key] = 0;
                    });

                    data.forEach(item => {
                      sizeFieldKeys.forEach(key => {
                        sizeTotals[key] += Number(item?.[key]) || 0;
                      });
                    });

                    const totalQty = data.reduce(
                      (acc, item) => acc + (parseFloat(item?.totalqty) || 0),
                      0
                    );

                    return (
                      <Table.Summary fixed>
                        <Table.Summary.Row>
                          <Table.Summary.Cell colSpan={21} />

                          {sizeFieldKeys.map(key => (
                            <Table.Summary.Cell key={key}>
                              <p style={{ textAlign: "right" }} className="totalquantity">
                                {Number(sizeTotals[key] || 0).toLocaleString("en-US")}
                              </p>
                            </Table.Summary.Cell>
                          ))}

                          <Table.Summary.Cell>
                            <p style={{ textAlign: "right" }} className="totalquantity">
                              {Number(totalQty).toLocaleString("en-US")}
                            </p>
                          </Table.Summary.Cell>

                        </Table.Summary.Row>
                      </Table.Summary>
                    );
                  }}
                />
              ) : (
                <div className="no-Data">
                  {/* {} */}
                  <h1>No Stock / Pending Order Data</h1>
                </div>
              )
            ) : (
              loading && (
                <div className="loader" style={{ marginTop: "20px" }}>
                  <Spin size="medium" />
                </div>
              )
            )
          }
        </div>
      </div>
    </div>
  );
}

export default AllocationReport;
